import Vue from 'vue'
export var bus = new Vue()
